import React from 'react';
import ControlResource from 'PAGES/Control/Resource/ControlResource';
import ScheduleDateForm from './ScheduleDateForm';

const ScheduleDate = () => (
  <ControlResource
    resource="settings"
    title="Newsletter day"
    resourceTypeId="0"
    form={<ScheduleDateForm />}
  />
);

export default ScheduleDate;



// WEBPACK FOOTER //
// ./src/pages/Control/Screens/ScheduleDate/ScheduleDate.js